/* eslint-disable camelcase */
import { User } from "@themuse/design-system";

import { Culture, EmployeeStory, ORMSingleCompany } from "interfaces/api/apiInterfaces";

export interface AppUser extends User {
    isInitialized: boolean;
}

export interface AppItem {
    value: string;
}

export interface AppState {
    user?: AppUser;
    company?: ORMSingleCompany | null;
    cultures?: Culture[];
    employeeStories?: EmployeeStory[];
}

export enum UserActionTypes {
    updateUser = "update_user",
    resetUser = "reset_user"
}

export interface UserAction {
    type: UserActionTypes;
    payload?: User;
}

export enum CompanyActionTypes {
    updateCompany = "update_company",
    resetCompany = "reset_company"
}

export interface CompanyAction {
    type: CompanyActionTypes;
    payload?: ORMSingleCompany;
}
export interface AppDispatch {
    (action: CompanyAction | UserAction): void;
}
